<template>
  <dv-scroll-board :config="config" style="width: 100%; height: 195px" />
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: ["资源库", "类型", "资源数量", "资源使用率"],
        data: [
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
          ["电子资源库", "课程资源", "251个", "92%"],
        ],
        rowNum: 4,
        waitTime: 5000,
        headerHeight: 35,
        columnWidth: [80],
        align: ["left"],
        index: true,
        indexHeader: "-",
        carousel: "page",
        hoverPause: true,
      },
    };
  },
};
</script>

<style>
</style>